module.exports = __webpack_public_path__ + "static/media/log_7.713b5683.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/log_7.jpg
// module id = 1896
// module chunks = 0